class PostForm {
	constructor() { }
	static postForm(form, successCallback, errorCallback) {
		var data = new FormData(form);
		var xhr = new XMLHttpRequest();
		xhr.open('POST', form.getAttribute("action"), true);
		xhr.onload = function () {
			if (this.status === 200) {
				if (successCallback) {
					successCallback(this.response);
				} else {
					console.log("success", this.response);
				}
			} else {
				if (errorCallback) {
					errorCallback(this.response);
				} else {
					console.log("error", this);
				}
			}
		};
		xhr.send(data);
	}
}
export { PostForm as default };